import { useSelector } from 'react-redux';

export function useCheckouts() {
    return useSelector((state) => state.checkout?.checkouts);
}

export function useCheckoutStatistic() {
    return useSelector((state) => state.checkout?.statistic);
}
